import Logo from "@/ui/components/Logo";
import ThinkingAnimation from "@/ui/components/ThinkingAnimation";

export default function Loading() {
  return (
    <div
      style={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        textAlign: "center",
        fontSize: "1.5rem",
        fontWeight: "bold",
        color: "#333",
        display: "flex",
        flexDirection: "column",
        gap: "24px",
        justifyContent: "center",
      }}
    >
      <Logo />
      <ThinkingAnimation />
    </div>
  );
}
